import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-color-f8 px-6 py-4 mb-8" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "font-size-18 font-bold mb-4" }
const _hoisted_4 = { class: "mb-4 grid grid-cols-3 gap-4 auto-cols-min grid-cols-fit" }
const _hoisted_5 = { class: "font-size-12 text-grey-999" }
const _hoisted_6 = { class: "font-size-14" }
const _hoisted_7 = { class: "font-size-12 text-grey-999" }
const _hoisted_8 = { class: "font-size-14" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "font-size-12 text-grey-999" }
const _hoisted_13 = { class: "font-size-14" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-close text-4xl" }, null, -1)
const _hoisted_18 = {
  key: 1,
  class: "flex justify-between font-size-14"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-chevron-down" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isExpandShiftPattern)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.t('availableWorkPatterns')), 1),
          _createVNode("div", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.shiftPatternData, (item) => {
              return (_openBlock(), _createBlock(_Fragment, {
                key: JSON.stringify(item)
              }, [
                _createVNode("div", null, [
                  _createVNode("div", _hoisted_5, _toDisplayString(item.shift_pattern_code), 1),
                  _createVNode("div", _hoisted_6, _toDisplayString(item.shift_pattern_name), 1)
                ]),
                _createVNode("div", null, [
                  _createVNode("div", _hoisted_7, _toDisplayString(_ctx.t('workingPatternHours')), 1),
                  _createVNode("div", _hoisted_8, [
                    (
                  !item.shift_pattern_times?.filter((e) => !e.is_break).length
                )
                      ? (_openBlock(), _createBlock("span", _hoisted_9, "-"))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.shift_pattern_times?.filter((e) => !e.is_break), (shiftPatternTime, index) => {
                      return (_openBlock(), _createBlock("span", {
                        key: JSON.stringify(shiftPatternTime)
                      }, [
                        (
                    index <
                    item.shift_pattern_times?.filter((e) => !e.is_break)
                      .length -
                      1
                  )
                          ? (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(shiftPatternTime.start_time) + "~" + _toDisplayString(shiftPatternTime.end_time) + ", ", 1))
                          : (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(shiftPatternTime.start_time) + "~" + _toDisplayString(shiftPatternTime.end_time), 1))
                      ]))
                    }), 128))
                  ])
                ]),
                _createVNode("div", null, [
                  _createVNode("div", _hoisted_12, _toDisplayString(_ctx.t('breakTime')), 1),
                  _createVNode("div", _hoisted_13, [
                    (
                  !item.shift_pattern_times?.filter((e) => e.is_break).length
                )
                      ? (_openBlock(), _createBlock("span", _hoisted_14, "-"))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.shift_pattern_times?.filter((e) => e.is_break), (shiftPatternTime, index) => {
                      return (_openBlock(), _createBlock("span", {
                        key: JSON.stringify(shiftPatternTime)
                      }, [
                        (
                    index <
                    item.shift_pattern_times?.filter((e) => e.is_break).length -
                      1
                  )
                          ? (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(shiftPatternTime.start_time) + "~" + _toDisplayString(shiftPatternTime.end_time) + ", ", 1))
                          : (_openBlock(), _createBlock("span", _hoisted_16, _toDisplayString(shiftPatternTime.start_time) + "~" + _toDisplayString(shiftPatternTime.end_time), 1))
                      ]))
                    }), 128))
                  ])
                ])
              ], 64))
            }), 128))
          ]),
          _createVNode("div", null, [
            _createVNode(_component_Button, {
              variant: "outline-primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isExpandShiftPattern = false))
            }, {
              default: _withCtx(() => [
                _hoisted_17,
                _createTextVNode(_toDisplayString(_ctx.t('closeBtn')), 1)
              ]),
              _: 1
            })
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_18, [
          _createVNode("div", null, _toDisplayString(_ctx.t('availableWorkPatterns')), 1),
          _createVNode("div", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isExpandShiftPattern = true)),
            class: "cursor-pointer text-light-blue hover:opacity-75"
          }, [
            _createTextVNode(_toDisplayString(_ctx.t('refer')), 1),
            _hoisted_19
          ])
        ]))
  ]))
}